import * as types from '../constants/ActionTypes';
import * as staticConstants from '../constants/staticConstants';
import {getBaseUrl} from '../../core/utility/filter.utility';
import getQueryStringValue from '../../web/components/url-reader/url-reader';

import {
    takeLatest,
    call,
    put
} from 'redux-saga/effects';

import axios from 'axios';

// reducer with initial state
const initialState = {
    aiccSId: null,
    launchedType: null,
    launchedUrl: null,
    videoCaption: null,
    audioUrl: null,
    videoType: null,
    learnerId: getQueryStringValue('learnerId'),
    error: null,
    contentDetails: {},
    lastLaunchedId: null
};

export function contentReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_CONTENT_DETAILS:
            return {...state,
                contentDetails: action.payload,
                error: null
            };
        case types.CONTENT_ERROR:
            return {...state,
                error: action.payload
            };
        case types.SET_LAUNCHED_TYPE:
            return {...state,
                launchedType: action.payload,
                error: null
            };
        case types.SET_LAUNCHED_URL:
            return {...state,
                launchedUrl: action.payload,
                error: null
            };
        case types.SET_VIDEO_CAPTION:
            return {...state,
                videoCaption: action.payload,
                error: null
            };
        case types.SET_AUDIO:
            return {...state,
                audioUrl: action.payload,
                error: null
            };
        case types.SET_TYPE_VIDEO:
            return {...state,
                videoType: action.payload,
                error: null
            };
        case types.SET_LAUNCHED_AICC_SESSION_ID:
            return {...state,
                aiccSId: action.payload,
                error: null
            };
        case types.SET_LEARNER_ID:
            return {...state,
                learnerId: action.payload,
                error: null
            };
        case types.SET_LAST_LAUNCHED:
            return {...state,
                lastLaunchedId: action.payload,
                error: null
            };
        default:
            return state;
    }
}

// function that makes the api request and returns a Promise for response
function getContent(reqObj) {
    // url: `${getBaseUrl}/getContentDetails.json`,
    // url: `${getBaseUrl()}/rest/up/authorizationService/getContentDetails`,
    // url: 'http://localhost:3000/contentDetails',
    return axios({
        method: 'post',
        url: `${getBaseUrl()}/rest/up/authorizationService/getContentDetails`,
        data: {
            cId: reqObj.cId,
            lcoId: reqObj.lcoId,
            lang: reqObj.lang,
            lmsUrl: reqObj.lmsUrl,
            learnerId: reqObj.learnerId,
            key: reqObj.sessionId,
            lId: reqObj.lId,
            cType: reqObj.cType,
            rc_Type: reqObj.rcType,
            audience: reqObj.audience || '',
            isGuide: reqObj.isGuide
        },
        headers: {
            Authorization: reqObj.sessionId
        }
    });
}

function getUrl(reqObj) {
    // url: 'http://localhost:3000/getLaunchUrl',
    // url: `${getBaseUrl()}/rest/up/launchService/getLaunchUrl`,
    // url: 'http://localhost//get-url.json',
    return axios({
        method: 'post',
        url: `${getBaseUrl()}/rest/up/launchService/getLaunchUrl`,
        data: {
            lcoId: reqObj.lcoId,
            bId: reqObj.bId,
            lang: reqObj.lang,
            key: reqObj.key,
            learnerId: reqObj.learnerId,
            skUid: reqObj.skUid,
            scUid: reqObj.scUid,
            pId: reqObj.pId || null,
            cId: (reqObj.cId || reqObj.cId === 0) ? reqObj.cId : null,
            lmsUrl: reqObj.lmsUrl,
            sLnch: reqObj.sLnch || false,
            audience: reqObj.audience || reqObj.isGuide ? 'a' : '',
            isGuide: reqObj.isGuide,
            lpId: reqObj.lpId
        },
        headers: {
            Authorization: reqObj.sessionId
        }
    });
}

// worker saga: makes the api call when watcher saga sees the action
function* contentWorkerSaga(request) {
    try {
        // console.log(request);
        const response = yield call(getContent, request.payload);
        const content = response.data;

        // Error Handling for getLaunchUrl
        if (content.err) {
            yield put({
                type: types.SET_EXCEPTION,
                payload: {
                    type: staticConstants.EXCP_ERROR,
                    desc: content.desc
                }
            });
            yield put({
                type: types.SET_LOADER,
                payload: false
            });
            return;
        }
        if (!content) {
            yield put({
                type: types.CONTENT_ERROR,
                payload: 'There has been some issue with 3DS Learning Space. Please try after sometime.'
            });
            yield put({
                type: types.SET_LOADER,
                payload: false
            });
            return;
        }
        // dispatch a success action to the store with the new dog
        yield put({
            type: types.SET_CONTENT_DETAILS,
            payload: content
        });
        yield put({
            type: types.SET_LOADER,
            payload: false
        });
    } catch (error) {
        // dispatch a failure action to the store with the error
        yield put({
            type: types.CONTENT_ERROR,
            payload: 'There has been some issue with 3DS Learning Space. Please try after sometime.'
        });
        yield put({
            type: types.SET_LOADER,
            payload: false
        });
    }
}

function* launchUrlWorkerSaga(request) {
    try {
        const response = yield call(getUrl, request.payload);

        // Error Handling for getLaunchUrl
        if (response.data.err) {
            yield put({
                type: types.SET_EXCEPTION,
                payload: {
                    type: staticConstants.EXCP_ERROR,
                    desc: response.data.desc
                }
            });
            yield put({
                type: types.SET_LOADER,
                payload: false
            });
            return;
        }
        if (!response) {
            yield put({
                type: types.SET_EXCEPTION,
                payload: {
                    type: staticConstants.EXCP_ERROR,
                    desc: 'Error getting Launch URL of requested LCO.'
                }
            });
            yield put({
                type: types.SET_LOADER,
                payload: false
            });
            return;
        }
        yield put({
            type: types.SET_LAUNCHED_URL,
            payload: response.data.URL
        });

        yield put({
            type: types.SET_LAUNCHED_AICC_SESSION_ID,
            payload: response.data.sId
        });

        yield put({
            type: types.SET_VIDEO_CAPTION,
            payload: response.data.caption
        });

        yield put({
            type: types.SET_AUDIO,
            payload: response.data.audio
        });

        yield put({
            type: types.SET_TYPE_VIDEO,
            payload: response.data.type
        });

        yield put({
            type: types.SET_LOADER,
            payload: false
        });
    } catch (error) {
        yield put({
            type: types.SET_EXCEPTION,
            payload: {
                type: staticConstants.EXCP_ERROR,
                desc: 'Error getting Launch URL of requested LCO.'
            }
        });
        yield put({
            type: types.SET_LOADER,
            payload: false
        });
    }
}

// watcher saga: watches for actions dispatched to the store, starts worker saga
export function* contentWatcherSaga() {
    yield takeLatest(types.GET_CONTENT_DETAILS, contentWorkerSaga);
    yield takeLatest(types.GET_LAUNCH_URL, launchUrlWorkerSaga);
}
